import * as _ from "lodash";
import * as moment from "moment";
import * as swal from "sweetalert";
import {AccountService} from "../../../account/core/services/AccountService";
import {IMinistryResource} from "../../../admin/core/services/MinistryService";
export class DatasetModalComponent implements ng.IComponentOptions {
  public controller: any = DatasetModalController;
  public bindings: any = {
    modalInstance: "<",
    resolve: "<"
  }
  public template: string = /*html*/`
  <div class="modal-header">
     <button type="button" class="close" ng-click="$ctrl.cancel()" aria-label="Close"  ng-disabled="$ctrl.submitting"><span aria-hidden="true">&times;</span></button>
     <h4 class="modal-title" id="datasetModal">{{$ctrl.title}}</h4>
   </div>
   <div class="modal-body" style="overflow:scroll">
     <form name="datasetForm" class="form-horizontal">
      <div class="form-group" ng-if="$ctrl.isAdmin">
        <label for="type" class="col-sm-3 control-label">Type</label>
        <div class="col-sm-9">
        <label for="type-raw" class="radio-inline">
          <input type="radio" id="type-raw" name="type" value="raw" ng-model="$ctrl.form.type" ng-click="$ctrl.form.publish = 'private'" ng-disabled="$ctrl.isEdit" ng-change="$ctrl.genCode()" /> Raw (Original)
        </label>
        <label for="type-raw-cl" class="radio-inline">
          <input type="radio" id="type-raw-cl" name="type" value="cleansed" ng-model="$ctrl.form.type" ng-click="$ctrl.form.publish = 'private'" ng-disabled="$ctrl.isEdit" ng-change="$ctrl.genCode()"/> Raw (Cleansed)
        </label>
        <label for="type-agg" class="radio-inline">
          <input type="radio" id="type-agg" name="type" value="aggregate" ng-model="$ctrl.form.type" ng-click="$ctrl.form.publish = 'public'" ng-disabled="$ctrl.isEdit" ng-change="$ctrl.genCode()"/> Aggregate
        </label>
        </div>
       </div>
       <div class="form-group" ng-if="$ctrl.isAdmin">
        <label for="type" class="col-sm-3 control-label">Publish</label>
        <div class="col-sm-9">
        <label for="publish-private" class="radio-inline">
          <input type="radio" id="publish-private" name="publish" value="private" ng-model="$ctrl.form.publish" ng-disabled="$ctrl.isEdit&&!$ctrl.isAdmin" /> Private
        </label>
        <label for="publish-internal" class="radio-inline">
          <input type="radio" id="publish-internal" name="publish" value="internal" ng-model="$ctrl.form.publish" ng-disabled="($ctrl.form.type === 'raw' || $ctrl.isEdit) && !$ctrl.isAdmin"/> Internal
        </label>
        <label for="publish-public" class="radio-inline">
          <input type="radio" id="publish-public" name="publish" value="public" ng-model="$ctrl.form.publish" ng-disabled="($ctrl.form.type === 'raw'||$ctrl.form.type === 'cleansed'||$ctrl.isEdit) && !$ctrl.isAdmin"/> Public
        </label>
        </div>
       </div>

       <!-- added GROUP by Faizal at 13/11/2019 -->
       <div class="form-group" ng-if="$ctrl.isAdmin && $ctrl.form.type === 'aggregate'">
       <label for="datatype" class="col-sm-3 control-label">Group</label>
       <div class="col-sm-9">
       <ui-select ng-model="$ctrl.form.group" name="group" required ng-disabled="$ctrl.submitting || ($ctrl.isEdit && !$ctrl.isAdmin)">
         <ui-select-match placeholder="Choose Group">
           <span ng-bind="$select.selected.name"></span>
         </ui-select-match>
         <ui-select-choices repeat="item in ($ctrl.group | filter: $select.search)">
           <span ng-bind="item.name"></span>
         </ui-select-choices>
       </ui-select>
       </div>
      </div>

       <div class="form-group" ng-if="$ctrl.isAdmin">
        <label for="datatype" class="col-sm-3 control-label">Ministry</label>
        <div class="col-sm-9">
        <ui-select ng-model="$ctrl.form.ministry" name="ministry" ng-change="$ctrl.updateDatatype(true)" required ng-disabled="$ctrl.submitting || ($ctrl.isEdit && !$ctrl.isAdmin)">
          <ui-select-match placeholder="Choose Ministry">
            <span ng-bind="$select.selected.display_name"></span>
          </ui-select-match>
          <ui-select-choices repeat="item in ($ctrl.ministry | filter: $select.search)">
            <span ng-bind="item.display_name"></span>
          </ui-select-choices>
        </ui-select>
        </div>
       </div>
       <div class="form-group" ng-if="$ctrl.isAdmin&&$ctrl.form.ministry">
        <label for="datatype" class="col-sm-3 control-label">Agency</label>
        <div class="col-sm-9">
        <ui-select ng-model="$ctrl.form.agency" name="agency" ng-change="$ctrl.updateDatatype()" ng-disabled="$ctrl.submitting || ($ctrl.isEdit && !$ctrl.isAdmin)">
          <ui-select-match placeholder="Choose Agency">
            <span ng-bind="$select.selected.display_name"></span>
          </ui-select-match>
          <ui-select-choices repeat="item in ($ctrl.form.ministry.agencies | filter: $select.search)">
            <span ng-bind="item.display_name"></span>
          </ui-select-choices>
        </ui-select>
        </div>
       </div>
       <div class="form-group" ng-if="!$ctrl.isOrg">
        <label for="datatype" class="col-sm-3 control-label">Dataset Type</label>
        <div class="col-sm-9">
        <ui-select ng-model="$ctrl.form.datatype" name="datatype" ng-change="$ctrl.genCode();$ctrl.updateFields($ctrl.form.datatype)" required ng-disabled="$ctrl.submitting||($ctrl.isEdit && !$ctrl.isAdmin)">
          <ui-select-match placeholder="Choose Datatype">
            <span ng-bind="$select.selected.display_name"></span>
          </ui-select-match>
          <ui-select-choices repeat="item in ($ctrl.datatypes | filter: $select.search)">
            <span ng-bind="item.display_name"></span>
          </ui-select-choices>
        </ui-select>
       </div>
       </div>
       <div ng-show="$ctrl.form.datatype && !$ctrl.isEdit && $ctrl.form.type !== 'aggregate' && $ctrl.form.type !== 'cleansed'" style="background-color: #E4D836; padding: 16px;margin-bottom:8px;display:flex">
        <i class="fa fa-fw fa-exclamation-circle" style="margin-right: 8px"></i>
        <div>
        <div class="row">
          <div class="col-md-12">
            <label class="control-label" style="text-align:left;font-weight:300; margin-top: 0; padding-top:0;">Expecting File Format: <u><strong style="font-size:22px">{{$ctrl.form.datatype.file_format}}</strong></u></label>
          </div>
        </div>
        <div class="row">
        <div class="col-md-12">
        <label class="control-label" style="text-align:left;font-weight:300">Expecting Variable/Column Name <small>(case sensitive) (CSV must follow variable sequence)</small></label>
        <textarea ng-model="$ctrl.expected_fields" class="form-control" disabled></textarea>
        </div>
        </div>
        </div>
      </div>
       <div class="form-group" ng-if="!$ctrl.isOrg">
        <label for="time" class="col-sm-3 control-label">Frequency</label>
        <div class="col-sm-9">
        <div class="row" ng-if="$ctrl.form.type === 'aggregate' || $ctrl.form.type === 'cleansed'">
          <div class="col-md-12">
            <ui-select ng-model="$ctrl.form.frequency" required name="frequency">
              <ui-select-match placeholder="Select Frequency">
                <span ng-bind="$select.selected.name"></span>
              </ui-select-match>
              <ui-select-choices repeat="item.code as item in ($ctrl.frequencies | filter: $select.search)">
                <span ng-bind="item.name"></span>
              </ui-select-choices>
            </ui-select>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6" ng-if="(($ctrl.form.datatype.frequency == 'm' || $ctrl.form.datatype.frequency == 'o') && !$ctrl.form.frequency) || $ctrl.form.frequency == 'm' || $ctrl.form.frequency == 'o'">
          <div class="input-group">
          <ui-select ng-model="$ctrl.form.month" name="month" ng-change="$ctrl.genCode()"  ng-disabled="$ctrl.submitting" required>
            <ui-select-match placeholder="{{($ctrl.form.datatype.frequency == 'o'|| $ctrl.form.frequency == 'o')?'Choose Start Month':'Choose Month'}}">
              <span ng-bind="$select.selected"></span>
            </ui-select-match>
            <ui-select-choices repeat="item in ($ctrl.months | filter: $select.search)">
              <span ng-bind="item"></span>
            </ui-select-choices>
          </ui-select>
          <span class="input-group-addon">Month</span>
          </div>
          </div>
          <div class="col-sm-6" ng-if="($ctrl.form.datatype.frequency == 'q' && !$ctrl.form.frequency) || $ctrl.form.frequency == 'q'">
          <div class="input-group">
          <ui-select ng-model="$ctrl.form.quarter" name="quarter" ng-change="$ctrl.genCode()"  ng-disabled="$ctrl.submitting" required>
            <ui-select-match placeholder="Choose Quarter">
              <span ng-bind="$select.selected.name"></span>
            </ui-select-match>
            <ui-select-choices repeat="item.val as item in ($ctrl.quarters | filter: $select.search)">
              <span ng-bind="item.name"></span>
            </ui-select-choices>
          </ui-select>
          <span class="input-group-addon">Quarter</span>
          </div>
          </div>
          <div class="col-sm-6" ng-if="($ctrl.form.datatype.frequency == 'b' && !$ctrl.form.frequency) || $ctrl.form.frequency == 'b'">
          <div class="input-group">
          <ui-select ng-model="$ctrl.form.half" name="half" ng-change="$ctrl.genCode()"  ng-disabled="$ctrl.submitting" required>
            <ui-select-match placeholder="Choose Half">
              <span ng-bind="$select.selected.name"></span>
            </ui-select-match>
            <ui-select-choices repeat="item.val as item in ($ctrl.halfs | filter: $select.search)">
              <span ng-bind="item.name"></span>
            </ui-select-choices>
          </ui-select>
          <span class="input-group-addon">Half</span>
          </div>
          </div>
          <div class="col-sm-6">
          <div class="input-group">
          <ui-select ng-model="$ctrl.form.year1" name="year1" ng-change="$ctrl.genCode()"  ng-disabled="$ctrl.submitting" required>
            <ui-select-match placeholder="{{($ctrl.form.datatype.frequency == 'o'|| $ctrl.form.frequency == 'o')?'Choose Start Year':'Choose Year'}}">
              <span ng-bind="$select.selected"></span>
            </ui-select-match>
            <ui-select-choices repeat="item in ($ctrl.years | filter: $select.search)">
              <span ng-bind="item"></span>
            </ui-select-choices>
          </ui-select>
          <span class="input-group-addon">Year</span>
          </div>
          </div>
          <div class="col-sm-6" ng-if="($ctrl.form.datatype.frequency == 'o' && !$ctrl.form.frequency) || $ctrl.form.frequency == 'o'">
          <div class="input-group">
          <ui-select ng-model="$ctrl.form.month2" name="month" ng-change="$ctrl.genCode()"  ng-disabled="$ctrl.submitting" required>
            <ui-select-match placeholder="Choose End Month">
              <span ng-bind="$select.selected"></span>
            </ui-select-match>
            <ui-select-choices repeat="item in ($ctrl.months | filter: $select.search)">
              <span ng-bind="item"></span>
            </ui-select-choices>
          </ui-select>
          <span class="input-group-addon">Month</span>
          </div>
          </div>
          <div class="col-sm-6" ng-if="($ctrl.form.datatype.frequency == 'o' && !$ctrl.form.frequency) || $ctrl.form.frequency == 'o'">
          <div class="input-group">
          <ui-select ng-model="$ctrl.form.year2" name="year2" ng-change="$ctrl.genCode()"  ng-disabled="$ctrl.submitting" required>
            <ui-select-match placeholder="Choose End Year">
              <span ng-bind="$select.selected"></span>
            </ui-select-match>
            <ui-select-choices repeat="item in ($ctrl.years | filter: $select.search)">
              <span ng-bind="item"></span>
            </ui-select-choices>
          </ui-select>
          <span class="input-group-addon">Year</span>
          </div>
          </div>
        </div>
        </div>
       </div>
       <div class="form-group">
         <label for="name" class="col-sm-3 control-label">Dataset Name</label>
         <div class="col-sm-9">
           <input type="text" name="name" class="form-control" id="name" placeholder="Name" ng-model="$ctrl.form.display_name" required ng-disabled="!$ctrl.isAdmin">
         </div>
       </div>
       <div class="form-group" ng-if="!$ctrl.isOrg">
         <label for="code" class="col-sm-3 control-label">Dataset Code</label>
         <div class="col-sm-9">
           <input type="text" name="code" class="form-control" id="code" placeholder="Code" ng-model="$ctrl.form.display_code"  required ng-disabled="!$ctrl.isAdmin" ng-change="$ctrl.isAdmin&&$ctrl.codeCheck($ctrl.form.display_code)">
         </div>
       </div>
       <div class="form-group">
        <label for="desc" class="col-sm-3 control-label">Description</label>
        <div class="col-sm-9">
         <textarea class="form-control" name="desc" id="desc" placeholder="Description" ng-model="$ctrl.form.description" ng-disabled="$ctrl.submitting"></textarea>
        </div>
       </div>
       <div class="form-group">
         <label for="tags" class="col-sm-3 control-label">Keywords</label>
         <div class="col-sm-9">
         <ui-select multiple tagging tagging-label="" ng-model="$ctrl.form.tags" ng-disabled="$ctrl.submitting">
         <ui-select-match placeholder="Select Tags">{{$item}}</ui-select-match>
         <ui-select-choices repeat="tag in $ctrl.tags | filter:$select.search">
          {{tag}}
         </ui-select-choices>
         </ui-select>
         </div>
       </div>
       <div class="form-group" ng-if="$ctrl.isAdmin">
        <label for="tags" class="col-sm-3 control-label">Related Dataset</label>
        <div class="col-sm-9">
        <ui-select multiple tagging tagging-label="" ng-model="$ctrl.form.linked" on-select="$ctrl.onDataset($item, $model)" ng-disabled="$ctrl.submitting">
        <ui-select-match placeholder="Dataset Id">{{$item.display_name}}</ui-select-match>
        <ui-select-choices repeat="dataset in $ctrl.dataset">
          {{dataset}}
        </ui-select-choices>
        </ui-select>
        </div>
       </div>
       <div class="form-group">
        <label for="file" class="col-sm-3 control-label">Data File</label>
        <div class="col-sm-9">
        <span class="small badge margin-bottom" ng-repeat="resource in $ctrl.form.resources">{{resource.originalname}} <span class="pointer" ng-click="$ctrl.deleteResource(resource)">&times;</span></span>
        <span class="small badge margin-bottom" ng-show="$ctrl.form.files" ng-repeat="file in $ctrl.form.files">{{file.name}} <span class="pointer" ng-click="$ctrl.deleteFile($index)">&times;</span></span>
        <div class="drop-box" ngf-select ngf-drop ngf-drag-over-class="'dragover'" ngf-multiple="true" ngf-pattern="'.csv,.xls,.xlsx,.xml,.json'" ngf-keep="true" accept=".csv,.xls,.xlsx,.xml,.json" ng-model="$ctrl.form.files" ng-disabled="$ctrl.submitting">Select or drop your file here</div>
        <div ngf-no-file-drop>File Drag/Drop is not supported for this browser</div>
        <span class="small">Maximum Size 200 Mb</span>
        </div>
       </div>
     </form>
   </div>
   <div class="modal-footer">
     <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()"  ng-disabled="$ctrl.submitting">Close</button>
     <button type="button" class="btn btn-primary" ng-click="datasetForm.$valid && $ctrl.save()" ng-disabled="$ctrl.submitting||$ctrl.duplicated"><i class="fa fa-fw fa-spinner fa-spin" ng-show="$ctrl.submitting"></i>{{$ctrl.submitting?"Submitting":"Save"}}</button>
   </div>
   <div class="overlay-loading" ng-show="$ctrl.submitting"></div>
   `;
}

export class DatasetModalController {
  public static $inject: Array<string> = ["AccountService", "Upload", "$timeout","$http", "MinistryService","$q"];
  public modalInstance: ng.ui.bootstrap.IModalServiceInstance;
  public resolve: any;
  public months: Array<number>;
  public Months: Array<string>;
  public years: Array<number>;
  public datatypes: Array<any>;
  public quarters: Array<any>;
  public halfs: Array<any>;
  public tags: Array<any>;
  public form: any;
  public submitting: boolean;
  public error: string;
  public error2: boolean;
  public error3: boolean;
  public error4: boolean;
  public error5: boolean;
  public error6: boolean;
  public categories: Array<any>;
  public group: Array<any>;
  public revision: number = 1;
  public progress: number;
  public duplicated: boolean;
  public title: string;
  public isAdmin: boolean;
  public isOrg: boolean;
  public ministry: Array<any>;
  public today: Date;
  public expected_fields: string[];
  public isEdit: boolean;
  public frequencies: {}[];
  public code: string;
  constructor (private account: AccountService, private Upload: ng.angularFileUpload.IUploadService, private $timeout: ng.ITimeoutService, private $http: ng.IHttpService, private Ministry: IMinistryResource, private $q: ng.IQService) {
    this.months = _.range(1,13);
    let _year = moment().year();
    this.today = new Date();
    this.years = _.range(_year - 10, _year + 1);
    if (account.isAdmin) {
      this.ministry = Ministry.query({allFields:true, state: 'active'});
    }
    else if (account.is_ministry)
      this.datatypes = account.ministry.datatypes;
    else if (account.agency)
      this.datatypes = account.agency.datatypes;
    this.quarters = [
      {name: "First", val: 1},
      {name: "Second", val: 2},
      {name: "Third", val: 3},
      {name: "Fourth", val: 4}
    ];
    this.halfs = [
      {name: "First", val: 1},
      {name: "Second", val: 2}
    ];
    this.Months = [
      'JAN', 'FEB', 'MAC', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'
    ];
    this.frequencies = [
      {name: "Time Series", code: "o"},
      {name: "Monthly", code: "m"},
      {name: "Quarterly", code: "q"},
      {name: "Annually", code: "a"},
      {name: "Biannually", code: "b"}
    ];
    this.tags = [];
    this.isAdmin = account.isAdmin;
    this.isOrg = account.usertype === 'external_org';
    $timeout(() => {
      if (this.resolve.dataset) {
        this.isEdit = true
        this.form = this.resolve.dataset;
        this.code = _.clone(this.resolve.dataset.code)
        this.title = "Edit Dataset Properties";
        if (!this.resolve.dataset.internal && !this.resolve.dataset.private) {
          this.form.publish = 'public';
        }
        if (this.resolve.dataset.private && !this.resolve.dataset.internal) {
          this.form.publish = 'private';
        }
        else if (!this.resolve.dataset.private && this.resolve.dataset.internal) {
          this.form.publish  = 'internal';
        }
        if (!this.isOrg) {
          let date = moment(this.form.data_date.start);
          let freq;
          if (this.form.frequency) {
            freq = this.form.frequency
          }
          else {
            freq = this.form.datatype.frequency
          }
          switch (freq) {
            case "m":
            this.form.month = date.month() + 1;
            this.form.year1 = date.year();
            break;
            case "q":
            this.form.quarter = date.quarter();
            this.form.year1 = date.year();
            break;
            case "a":
            this.form.year1 = date.year();
            break;
            case "b":
            this.form.half = Math.round(date.quarter()/2);
            this.form.year1 = date.year();
            break;
            case "o":
            this.form.month = date.month() + 1;
            this.form.year1 = date.year();
            this.form.month2 = moment(this.form.data_date.end).month() + 1;
            this.form.year2 = moment(this.form.data_date.end).year();
            console.log(this.form.year2)
            break;
          }
        }
      }
      else {
        this.title = "Add Dataset";
      }
    })
    $http.get(`${BASE}/classification`)
    .then((d:any) => {
      this.categories = d.data;
      this.group = d.data.filter(c => c.type == 'group');
      this.group.sort(function(a,b){
        return a.name.localeCompare(b.name)
      });
    })
  }

  public updateDatatype(agency) {
    if (this.form.ministry && this.form.agency && !agency) {
      this.datatypes = this.form.agency.datatypes;
      this.form.datatype = "";
    }
    else if (this.form.ministry) {
      this.datatypes = this.form.ministry.datatypes;
      this.form.datatype = "";
      this.form.agency = "";
    }
    return true;
  }

  public cancel() {
    this.modalInstance.dismiss("canceled");
  }

  public save() {
    this.error = '';
    this.error2 = false;
    this.error3 = false;
    this.error4 = false;
    this.error5 = false;
    this.error6 = false;
    this.submitting = true;
    this.form.name = this.form.display_name.split(' ').join('_').toLowerCase();
    this.form.admin = this.isAdmin;
    if (this.form.datatype && this.form.datatype.agency) {
      if (!this.form.agency)
        this.form.agency = {}
      this.form.agency._id = this.form.datatype.agency;
    }
    if (this.form.datatype && this.form.datatype.ministry)
      if (!this.form.ministry)
        this.form.ministry = {}
      this.form.ministry._id = this.form.datatype.ministry;
    if (this.account.usertype === 'external_org') {
      this.form.external = true;
      this.form.private = true;
      this.form.is_processed = true;
      this.form.organization = this.account.organization.name;
    }
    if (this.form.publish === 'private') {
      this.form.private = true
      this.form.internal = false
    }
    else if (this.form.publish === 'internal') {
      this.form.private = false
      this.form.internal = true
    }
    else if (this.form.publish === 'public') {
      this.form.private = false
      this.form.internal = false
    }
    else {
      this.form.private = true
    }
    if (this.isAdmin) {
      if (this.form.display_code.indexOf(this.form.code) === -1) {
        const init = this.form.display_code.lastIndexOf('(');
        const fin = this.form.display_code.lastIndexOf(')');
        const version = parseInt(this.form.display_code.substr(init+1,fin-init-1))
        if (version && !_.isNaN(version))
          this.form.version = version
        else 
          this.form.version  = 0
        const nonversionCode = this.form.display_code.substr(0, init)
        const reg = /\d+$/
        const variant = reg.exec(nonversionCode)
        if (_.isNumber(variant[0])) {
          this.form.variant = variant[0]
          this.form.code = _.replace(nonversionCode, this.form.variant, '')
        }
        else {
          this.form.code = nonversionCode
        }
      }
    }
    if (this.form.datatype) {
      let frequency
      if (this.form.type === 'aggregate' || this.form.type === 'cleansed')
        frequency = this.form.frequency
      else 
        frequency = this.form.datatype.frequency
      switch (frequency) {
        case "m":
          let _start = moment([this.form.year1, this.form.month-1]);
          this.form.data_date = {
            start: _start.toDate(),
            end: moment(_start).endOf("month").toDate()
          }
          break;
        case "q":
          this.form.data_date = {
            start: moment([this.form.year1]).quarter(this.form.quarter).toDate(),
            end: moment([this.form.year1]).quarter(this.form.quarter + 1).subtract(1, 'ms').toDate()
          }
          break;
        case "a":
          this.form.data_date = {
            start: moment([this.form.year1]).toDate(),
            end: moment([this.form.year1 + 1]).subtract(1,'ms').toDate()
          }
          break;
        case "b":
          this.form.data_date = {
            start: moment([this.form.year1]).quarter(this.form.half*2 - 1).toDate(),
            end: moment([this.form.year1]).quarter(this.form.half*2 + 1).subtract(1, 'ms').toDate()
          }
          break;
        case "o":
          this.form.data_date = {
            start: moment([this.form.year1, this.form.month-1]).toDate(),
            end: moment([this.form.year2, this.form.month2-1]).endOf('month').toDate()
          }
          break;
      }
    }

    if (!this.account.isAdmin) {
      this.form.type = "raw";
    }

    if (this.form.linked && this.form.linked.length) {
      this.form.linked = _.map(this.form.linked, (dataset:any) => {
        return dataset._id;
      })
    }

    if (this.account.isAdmin && !this.form.private) {
      this.form.private = false;
      this.form.status = 'cleansed';
    }

    let unwanted = ['$promise', '$resolved', '$delete', '$query', '$get', '$remove', '$save', '$update', 'toJSON'];

    if (!this.form.agency) {
      unwanted.push('agency');
    }

    if (!this.form.ministry){
      unwanted.push('ministry');
    }
    let promise;
    if (this.form.id) {
      promise = this.$q.resolve()
    }
    else {
      promise = this.$http.post(`${BASE}/api/datasetCode`, {code: this.form.code})
    }
    promise
    .then((d:any) => {
      this.duplicated = false;
      if (d && d.data) {
        let data = d.data;
        if (((data.quality && data.quality === 'poor') || data.deletedOn) && this.form.version > data.version) {
          return this.$q.resolve();
        }
        else if (this.form.publish === 'public' && this.form.type === 'aggregate' && this.form.variant > data.variant) {
          return this.$q.resolve();
        }
        else {
          this.duplicated = true;
          swal("Sorry!", "The selected datatype and the frequency has already been upload before. Please delete the existing dataset record to try again OR select other datatype or frequency to continue.", "warning")
          return this.$q.reject();
        }
      }
      else {
        return this.$q.resolve();
      }
    })
    .then(() => {
      let request = {
        url: "api/dataset",
        data: _.omit(this.form, unwanted),
        method: "POST",
        arrayKey: ''
      }
      if (this.form._id) {
        request.url = `api/dataset/${this.form._id}`;
        request.method = "PUT";
        if ((!this.form.resources || this.form.resources.length === 0) && (!this.form.files || this.form.files.length === 0)) {
          this.error3 = true;
          this.error = 'Dataset cannot be empty.';
          swal("Error Occurs!", this.error, "warning")
          this.submitting = false;
          return;
        }
      }
      else if (!this.form.files || this.form.files.length === 0){
        this.error = 'Looks like you forgot to attach a dataset.';
        swal("Error Occurs!", this.error, "warning")
        this.submitting = false;
        return;
      }
      console.log(request)
      return this.Upload.upload(request)
    })
    .then(resp => {
      this.submitting = false;
      this.modalInstance.close(resp.data);
    })
    .catch(err => {
      console.log(err)
      if (err.data.error && err.data.error.code === 109) {
        this.error = 'Duplicated Dataset, please try with another name.';
      }
      else if (err.data.error && err.data.error.code === 100) {
        this.error = 'Variable/column is missing. Please check again.';
      }
      else if (err.data.error && err.data.error.code === 107) {
        this.error = 'Variable/column names do not match. Please check again.';
      }
      else if (err.data.error && err.data.error.code === 110) {
        this.error = 'Dataset file format not match.';
      }
      else
        this.error = 'Data failed to upload, please try again.';
      swal("Error Occurs!", this.error, "warning")
      this.submitting = false;
    })

  }

  public deleteFile(idx) {
    this.form.files.splice(idx, 1);
  }

  public deleteResource(resource) {
    if (resource && resource._id) {
      swal({
        title: "Confirmation",
        text: `Are you sure you want to remove ${resource.originalname}`,
        type: 'warning',
        showCancelButton: true
      }, (confirm) => {
        if (confirm) {
          this.$http.delete(`${BASE}/api/dataset/${this.form._id}/resource/${resource._id}`)
          .then(() => {
            this.form.resources = _.reject(this.form.resources, {_id: resource._id});
          })
        }
      })
    }
  }

  public onDataset(item, model) {
    return this.$http.get(`${BASE}/api/dataset/${model}`).then((datasets) => {
      this.form.linked.pop()
      this.form.linked.push(datasets.data);
    })
  }

  public updateFields(datatype) {
    this.expected_fields = _.sortBy(datatype.expected_fields, ['sequence']).map((d:any) => d.name)
  }

  public genCode() {
    let code:string = "";
    if (this.form.datatype || this.form.frequency) {
      if (this.form.frequency) {
        this.form.datatype.frequency = null
      }
      code = (_.find(this.categories, {name: this.form.datatype.category})).code;
      this.form.display_name = this.form.datatype.display_name;
      if (this.isAdmin)
        code += `/${this.form.ministry.code}`;
      else
        code += `/${this.account.ministry.code}`;
      if (!this.form.datatype.is_ministry) {
        if (this.isAdmin)
          code += `/${this.form.agency.code}`;
        else
          code += `/${this.account.agency.code}`;
      }
      code += `/${this.form.datatype.code}`;
      if (this.form.datatype.frequency === 'a' || this.form.frequency === 'a') {
        this.form.display_name += ` ${this.form.year1}`
        code += `/Y-${this.form.year1}`
      }
      else if (this.form.datatype.frequency === 'b' || this.form.frequency === 'b') {
        let date: string
        if (this.form.half === 1) {
          date = `JAN ${this.form.year1} - JUN ${this.form.year1}`
        }
        else {
          date = `JUL ${this.form.year1} - DEC ${this.form.year1}`
        }
        this.form.display_name += ` ${date}`
        code += `/B${this.form.half}-${this.form.year1}`
      }
      else if ((this.form.datatype.frequency === 'q' || this.form.frequency === 'q') && this.form.quarter && this.form.year1) {
        if (this.form.quarter === 1)
          this.form.display_name += ` 1st Quarter ${this.form.year1}`
        else if (this.form.quarter === 2)
          this.form.display_name += ` 2nd Quarter ${this.form.year1}`
        else if (this.form.quarter === 3)
          this.form.display_name += ` 3rd Quarter ${this.form.year1}`
        else if (this.form.quarter === 4)
          this.form.display_name += ` 4th Quarter ${this.form.year1}`
        code += `/Q${this.form.quarter}-${this.form.year1}`
      }
      else if ((this.form.datatype.frequency === 'm' || this.form.frequency === 'm') && this.form.month && this.form.year1) {
        this.form.display_name += ` ${this.Months[this.form.month-1]} ${this.form.year1}`
        code += `/M-${this.Months[this.form.month-1]}${this.form.year1}`
      }
      else if ((this.form.datatype.frequency === 'o' || this.form.frequency === 'o') && this.form.year2 && this.form.year1 && this.form.month && this.form.month2) {
        this.form.display_name += `${this.Months[this.form.month-1]} ${this.form.year1} - ${this.Months[this.form.month2-1]} ${this.form.year2}`
        code += `/OF-${this.Months[this.form.month-1]}${this.form.year1}-${this.Months[this.form.month2-1]}${this.form.year2}`
      }
      if (this.isAdmin && this.form.agency) {
        this.form.display_name += ` (${this.form.agency.code})`
      }
      else if (this.isAdmin && this.form.ministry) {
        this.form.display_name += ` (${this.form.ministry.code})`
      }
      if (_.get(this.account, 'agency.code', '')) {
        this.form.display_name += ` (${this.account.agency.code})`
      }
      else if (_.get(this.account, 'ministry.code', '')) {
        this.form.display_name += ` (${this.account.ministry.code})`
      }
      if (this.form.type === 'aggregate') {
        code += '/AG'
        this.form.display_name += ' (Aggregated)'
      }
      if (this.form.type === 'cleansed') {
        code += '/RC'
        this.form.display_name += ' (Cleansed)'
      }
    }
    if (this.code === code) {
      return
    }
    this.codeCheck(code)
  }

  public codeCheck(code: string) {
    this.$http.post(`${BASE}/api/datasetCode`, {code: code})
    .then((d:any) => {
      this.duplicated = false;
      let data = d.data;
      if (data) {
        if ((data.quality && data.quality === 'poor') || data.deletedOn) {
          data.version++
        }
        else if (this.form.publish === 'public' && this.form.type === 'aggregate') {
          data.variant++
        }
        else {
          this.duplicated = true;
          swal("Sorry!", "This datatype has been uploaded before, please select another one.", "warning")
        }
      }
      this.form.code = code;
      this.form.display_code = code;
      if (data.variant) {
        this.form.display_code += data.variant
      }
      if (data.version) {
        this.form.display_code += `(${data.version})`
      }
      this.form.version = data.version;
      this.form.variant = data.variant;
    })
  }
 
}
